import styled from "styled-components";

export const KnockOrderStyle = styled.div`
  /* 줄임말 공통 */
  h4.info {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  /* text공통 */
  h1 {
    font-size: 32px;
    color: #333333;
    line-height: 36px;
    font-weight: 600;
    margin-bottom: 4px;
  }
  h2 {
    font-size: 24px;
    line-height: 28px;
    color: #333333;
    font-weight: 600;
    white-space: nowrap;
  }
  h2.orderType {
    padding-top: 26px;
    padding-bottom: 4px;
  }

  .deliveryBadge {
    padding: 4px 10px;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: -12px;
    background: linear-gradient(90deg, #4fd3b0 0%, #91c3e7 100%);
    border-radius: 50px;
    p {
      white-space: nowrap;
      font-size: 12px;
      line-height: 14px;
      color: #ffffff;
      font-weight: 500;
    }
  }
  .deliveryBadge.cancel {
    background: linear-gradient(90deg, #ff5f5f 0%, #da79e1 100%);
  }

  h4 {
    color: #333333;
    font-weight: 400;
  }
  p {
    font-size: 12px;
    line-height: 14px;
    font-weight: 400;
    color: #999999;
  }

  .orderListWrap {
    padding: 36px 0 10px 0;
    margin: 0 3vw;
    border-bottom: 1px solid #d9d9d9;
  }

  .testOrder {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    border: 2px solid #ff3542;
    border-radius: 10px;
    pointer-events: none;
    touch-action: none;
    .header {
      width: 94%;
      margin: 0 auto;
      background-color: #ff3542;
      border-radius: 0 0 10px 10px;
      text-align: center;
      h5 {
        font-size: 14px;
        line-height: 24px;
        font-weight: 600;
        color: #fff;
      }
    }
  }

  .orderList {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: stretch;
  }

  .chatButton {
    display: flex;
    align-items: center;
    gap: 4px;
    /* background: #ffeeee; */
    background: #fff;
    border: 1px solid #ff4a4a;
    border-radius: 5px;
    padding: 6px 10px;
    h5 {
      font-weight: 500;
      color: #ff4a4a;
    }
    img {
      height: 15px;
    }
  }

  .listLeft {
    position: relative;
    min-width: 120px;
    width: 120px;
    text-align: center;
    display: flex;
    flex-direction: column;
  }

  .listCenter {
    max-width: 100%;
    width: 100%;
    padding: 0 10px 10px 40px;
    overflow: hidden;

    .flexItem.title {
      width: 50%;
      max-width: 20vw;
    }
    .flexItem {
      width: 25%;
    }
    .flexItem.right {
      text-align: right;
    }

    .requestText {
      width: 100%;
      color: #999999;
      font-size: 20px;
      line-height: 24px;
      font-weight: 600;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
    .requestText.detail {
      white-space: normal;
      text-overflow: clip;
      overflow: visible;
    }

    .detailListWrap {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 20px;
      gap: 10px;
      .row {
        display: flex;
        align-items: center;
        gap: 80px;
      }
    }

    h3 {
      font-weight: 400;
      color: #999999;
      padding: 10px 0;
    }
  }

  /* 자세히 보기 클릭시 세부 정보 */
  .orderList.detail {
    width: 100%;
    padding-top: 30px;
    align-items: flex-start;
    position: relative;

    h3 {
      color: #333333;
      font-weight: 600;
      padding: 0;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }

    .flexItem.address {
      display: flex;
      flex-direction: column;
      gap: 8px;
      flex: 4;
      .row {
        gap: 8px;
        align-items: flex-start;
      }
      .row.center {
        gap: 10px;
        align-items: center;
      }

      h3 {
        white-space: normal;
      }
    }

    .listLeft {
      padding-left: 14px;
      text-align: left;
    }
    .detailWrap {
      width: 100%;
      .detailItem {
        width: 100%;
        display: flex;
        margin-bottom: 30px;
      }
      .detailItem.sub {
        margin-bottom: 4px;
      }
    }
    .listCenter {
      h3 {
        font-weight: 500;
      }
      h3.address {
        white-space: normal;
        font-weight: 400;
        line-height: 24px;
      }
      .detailListWrap {
        align-items: flex-start;
        margin-bottom: 0;
      }
      .detailListWrap.tip {
        max-width: 100%;
        margin-bottom: 6px;
      }
    }
    .listCenter.right {
      text-align: right;
    }
    .optionListWrap {
      display: flex;
      align-items: flex-start;
      gap: 6px;
      padding: 4px 0;
      .row {
        display: flex;
        align-items: flex-start;
        gap: 8px;
        margin-bottom: 2px;
        flex-wrap: wrap;
        h4 {
          white-space: nowrap;
        }
        .row.option {
          border-left: 1px solid #333333;
          gap: 6px;
          padding: 0 0 0 6px;
          h5 {
            white-space: normal;
            word-break: break-all;
            font-size: 13px;
            line-height: 16px;
            font-weight: 400;
            color: #444444;
          }
        }
      }
    }

    /* 버튼 */
    .listRight {
      margin-left: 140px;
      min-width: 140px;
      width: 140px;
      display: flex;
      gap: 10px !important;
      flex-direction: column;
      align-items: flex-end;
      button {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 120px;
        padding: 30px 0;
        background: #ffffff;
        border: 1px solid #999999;
        color: #000000;
        border-radius: 5px;
        h4 {
          font-weight: 600;
        }
      }
      button.call {
        background-color: #82bbde;
        border-color: #82bbde;
        h4 {
          color: #fff;
        }
      }
      button.cancel {
        border-color: #ff616b;
        h4 {
          color: #ff616b;
        }
      }
      .row {
        display: flex;
        align-items: center;
        gap: 6px;
        button {
          min-width: 57px;
          width: 57px;
          padding: 24px 0;
          h4 {
            font-size: 14px;
          }
        }
      }
    }
  }
  .orderDetailListWrap {
    max-width: 100%;
    margin-bottom: 16px;
  }

  .arrowDown {
    text-align: center;
    cursor: pointer;
    img {
      margin-left: -100px;
    }
  }

  .copyButton {
    width: min-content;
    display: flex;
    align-items: center;
    color: #000000;
    background-color: #fff;
    border: 1px solid #999999;
    border-radius: 3px;
    font-size: 14px;
    line-height: 18px;
    font-weight: 400;
    padding: 2px 6px;
    white-space: nowrap;
    gap: 2px;
    cursor: pointer;
  }
  .copyButton.disabled {
    color: #ffffff;
    background: #b2b2b2;
    border: 1px solid #b2b2b2;
  }
`;

export const ButtonStatusStyle = styled.div`
  /* 줄임말 공통 */
  h4.info {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  /* text공통 */
  h1 {
    font-size: 32px;
    color: #333333;
    line-height: 36px;
    font-weight: 600;
    margin-bottom: 4px;
  }
  h2 {
    font-size: 24px;
    line-height: 28px;
    color: #333333;
    font-weight: 600;
    white-space: nowrap;
  }
  h2.orderType {
    padding-top: 26px;
    padding-bottom: 4px;
    color: #4dd2ae;
  }
  h4 {
    color: #333333;
    font-weight: 400;
  }
  p {
    font-size: 12px;
    line-height: 14px;
    font-weight: 400;
    color: #999999;
  }

  .listRight {
    min-width: 280px;
    width: 280px;
    display: flex;
    gap: 10px !important;
    justify-content: flex-end;

    .circleWrap {
      position: relative;
      padding: 10px;
      width: 150px;
      height: 150px;

      @keyframes rotateGradient {
        0% {
          background-position: 0% 0%;
        }
        100% {
          background-position: 100% 100%;
        }
      }

      .donut {
        position: relative;
        width: 100%;
        aspect-ratio: 1/1;
        margin: 0 auto;
        border-radius: 50%;
        position: relative;
        text-align: center;
      }
      .circleContent {
        position: absolute;
        width: 85%;
        aspect-ratio: 1/1;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        border-radius: 50%;
        background: #ffffff;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-top: 25%;
        z-index: 1;

        h3 {
          font-weight: 600;
        }
        h5 {
          padding-top: 6px;
          font-weight: 500;
        }
        h5.completeTime {
          color: #999999;
        }
        h5.plus {
          color: #ff3542;
        }
        h5.minus {
          color: #000000;
        }

        .loadingDots {
          display: flex;
          align-items: center;
          justify-content: center;
          padding-top: 6px;
          gap: 12px;

          @keyframes changeColor {
            0% {
              background: #4dd2ae;
            }
            50% {
              background: #d1d1d1;
            }
          }
          .dot {
            width: 6px;
            height: 6px;
            border-radius: 50%;
            background-color: #d1d1d1;
            animation: changeColor 2s infinite;
          }
          .dot:nth-child(2) {
            animation-delay: 0.5s;
          }
          .dot:nth-child(3) {
            animation-delay: 1s;
          }
          .dot:nth-child(4) {
            animation-delay: 1.5s;
          }
        }
      }
    }
    .circleContent.cancel {
      padding-top: calc(100% / 3);
    }

    .emergencyWrap {
      position: absolute;
      top: -24px;
      left: 50%;
      transform: translateX(-50%);
      display: flex;
      flex-direction: column;
      align-items: center;
      z-index: 1;
      p {
        position: relative;
        font-size: 10px;
        line-height: 12px;
        color: #ff4a4a;
        font-weight: 600;
        padding: 2px 8px;
        border-radius: 50px;
        border: 1px solid #ff4a4a;
        background: #fff;
        white-space: nowrap;
        margin-bottom: 3px;
      }
      p::after {
        content: "";
        position: absolute;
        bottom: -6px;
        left: 50%;
        transform: translateX(-50%);
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 6px 4px 0 4px;
        border-color: #ff4a4a transparent transparent transparent;
      }
      p::before {
        content: "";
        position: absolute;
        bottom: -4px;
        left: 50%;
        transform: translateX(-50%);
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 6px 4px 0 4px;
        border-color: white transparent transparent transparent;
        z-index: 1;
      }
      img {
        height: 37px;
      }
    }
    .emergencyWrap.blink {
      p {
        color: #fff;
        border: 1px solid #ff4a4a;
        background: #ff4a4a;
      }
      p::after {
        border-color: #ff4a4a transparent transparent transparent;
      }
      p::before {
        border-color: #ff4a4a transparent transparent transparent;
      }
    }

    .buttonContainer {
      position: relative;
      border-radius: 5px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      width: 120px;
      height: 150px;
      outline: none;
      box-shadow: 4px 4px 4px 0px rgba(0, 0, 0, 0.25);
      cursor: pointer;
      h3 {
        color: #ffffff;
        font-weight: 600;
      }

      .buttonWrap {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        text-align: center;
        white-space: pre-line;
        position: relative;

        h4 {
          margin-bottom: -20px;
          line-height: 50px;
          color: #ffffff;
        }
        h4.cancel {
          position: absolute;
          top: 100px;
          font-size: 14px;
          line-height: 18px;
          color: #ff3542;
        }
        p {
          font-size: 10px;
          color: #fff;
          font-weight: 600;
        }
      }
    }
    .buttonContainer.delivery {
      background: #4dd2ae;
      border: 1px solid #4dd2ae;
    }
    .buttonContainer.throo {
      background: #5991ff;
      border: 1px solid #5991ff;
    }
    .buttonContainer.packing {
      background: #fd7441;
      border: 1px solid #fd7441;
    }
    .buttonContainer.delivery.notCheck {
      background: #dffff6;
      h3 {
        color: #4dd2ae;
      }
    }
    .buttonContainer.throo.notCheck {
      background: #dffff6;
      h3 {
        color: #4dd2ae;
      }
    }
    .buttonContainer.packing.notCheck {
      background: #dffff6;
      h3 {
        color: #4dd2ae;
      }
    }
    .buttonContainer.disabled {
      cursor: default;
      background: #b2b2b2;
      border: 1px solid #b2b2b2;
      box-shadow: none;
    }
    .buttonContainer.disabled.notCheck {
      background: #f0f0f0;
      h3 {
        color: #b2b2b2;
      }
    }
    .buttonContainer.cancel {
      cursor: default;
      border: 1px solid #ff3542;
      background: #ffffff;
      h3 {
        color: #ff3542;
      }
    }

    .timeSelectBox {
      width: 100%;
    }
    .statusDetailText {
      padding: 11px 10px;
      border-bottom-right-radius: 5px;
      border-bottom-left-radius: 5px;
      text-align: center;
      font-size: 14px;
      line-height: 20px;
      color: #fff;
      font-weight: 500;
      white-space: nowrap;
    }
  }
`;
